<template>
  <div>
    <!--确认框-->
    <div v-if="visible">
      <div class="blackLayerbg"></div>
      <div class="tipsLayer">
        <b>提示</b>
        <p><slot></slot></p>
        <div class="botBut" v-if="!notice">
          <a href="javascript:;" @click="cancel">取消</a>
          <a href="javascript:;" @click="confrim" class="blueBut">确定</a>
        </div>
        <div class="botBut" v-if="notice">
          <a href="javascript:;" @click="cancel" class="blueBut">关闭</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "confirm-dialog",
  data() {
    return {
      visible: false,
      notice: false,
    };
  },
  methods: {
    init(ok, notice) {
      this.visible = true;
      this.ok = ok;
      this.notice = notice ? true : false;
    },
    cancel() {
      this.visible = false;
    },
    confrim() {
      this.ok();
      this.cancel();
    },
  },
};
</script>
